import { MISSING_TRACKING_DATA } from '@owc-packages/Tracking/src/Tracking.config';
import { NewChainNode } from '@owc-types/Header';
import { TrackingInstance } from '@owc-packages/Tracking/src/Tracking';
import initializeTracking from '@owc-packages/Tracking/src/TrackingUtils';

let trackingInstance: TrackingInstance | null = null;

export const _addToChain = (currentChain: string[] | undefined, payload: NewChainNode) => {
  const flyoutLevelToIndex = payload.flyoutLevel ? payload.flyoutLevel - 1 : 1;
  const flyoutLevel = flyoutLevelToIndex + 1;

  let finalString = [];

  if (currentChain) {
    currentChain[flyoutLevelToIndex] = payload.infoToAdd || MISSING_TRACKING_DATA;
    finalString = [...currentChain];
  } else {
    finalString[flyoutLevelToIndex] = payload.infoToAdd || MISSING_TRACKING_DATA;
  }

  finalString.splice(flyoutLevel, finalString.length);
  return finalString;
};

export const _removeFromChain = (currentChain: string[] | undefined, isClose: boolean) => {
  let newChain: string[] = [];

  if (currentChain && !isClose && currentChain.length > 0) {
    newChain = [...currentChain];
    newChain.pop();
  }

  return newChain;
};

export const _submitTrackingInfoWhenReady = async (
  trackingInfo: { label: string; url: string; flyoutLevel: number },
  newTrackingTree: string[] | undefined,
  headerParent: Element,
) => {
  const navigationLinkLabel = trackingInfo.label;
  const flyoutLevel = trackingInfo.flyoutLevel;

  trackingInstance = await initializeTracking();

  newTrackingTree = _addToChain(newTrackingTree, { infoToAdd: navigationLinkLabel, flyoutLevel });
  newTrackingTree = newTrackingTree.filter(Boolean);

  trackingInstance.customTrackingObjectUpdate(
    { label: newTrackingTree.join(':'), URL: trackingInfo.url },
    'click',
    headerParent,
  );
};
